import { Progress, Space, Spin } from 'antd';
import React, { PropsWithChildren } from 'react';

function ProgressDetail({ message, percent }: { message?: string; percent?: number }) {
  return (
    <Space orientation="vertical">
      {message}
      {percent !== undefined && <Progress percent={percent} status="active" size={{ width: 400 }} showInfo={false} />}
    </Space>
  );
}

export default function LoadingOverlay(props: PropsWithChildren<{ loading: boolean; message?: string; percent?: number }>) {
  const { children, loading, message, percent } = props;
  return (
    <Spin
      spinning={loading}
      prefixCls={message ? 'ant-spin-cfl-with-message' : 'ant-spin-cfl'}
      tip={message && <ProgressDetail message={message} percent={percent} />}
    >
      {children}
    </Spin>
  );
}
